export default __webpack_public_path__ + "static/media/9d84d5efe8c00aa38afbb52f87a0c1b6.svg";